// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S1gS","content":"styles_content__1xgRL"};